import React from "react";
import ReportUser from "../components/Report";

const Report = () =>{
    return (
        <div>
           <ReportUser/>
        </div>
    )
}
export default Report;